import React from 'react'
import Gadgetcomp from '../../components/caseComponent/gadgetifyComp/gadgetifycomp'


const Gadgetify = () => {
  return (
    <div>
      <Gadgetcomp />
    </div>
  )
}

export default Gadgetify
